import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpeedReadingHeaderComponent } from './speed-reading-header.component';

@NgModule({
  declarations: [SpeedReadingHeaderComponent],
  exports: [SpeedReadingHeaderComponent],
  imports: [CommonModule],
})
export class SpeedReadingHeaderModule {}
